<template>
  <div class="app-container">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <el-radio-group v-model="queryParams.isRead" @change="handleQuery">
            <el-radio-button :label="false">未读</el-radio-button>
            <el-radio-button :label="true">已读</el-radio-button>
          </el-radio-group>
        </div>
      </template>

      <el-table
        v-loading="loading"
        :data="notificationList"
        style="width: 100%"
      >
        <el-table-column prop="subject" label="主题" min-width="150" />
        <el-table-column prop="content" label="内容" min-width="300" show-overflow-tooltip />
        <el-table-column prop="senderName" label="发起人" width="120" align="center" />
        <el-table-column prop="createTime" label="发起时间" width="180" align="center" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template #default="scope">
            <el-button
              v-if="!scope.row.isRead"
              type="primary"
              link
              @click="handleMarkAsRead(scope.row)"
            >置为已读</el-button>
            <el-button
              type="primary"
              link
              @click="handleGoTo(scope.row)"
            >前往</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          v-model:current-page="queryParams.page"
          v-model:page-size="queryParams.size"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="getList"
          @current-change="getList"
        />
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { getNotificationPage, markAsRead } from '@/apis/notification'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { NotificationActionTypes } from '@/store/modules/notification/action-types'

export default defineComponent({
  name: 'Notification',
  setup() {
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      loading: false,
      notificationList: [],
      total: 0,
      queryParams: {
        page: 1,
        size: 10,
        isRead: false
      }
    })

    const getList = async () => {
      state.loading = true
      try {
        const data = await getNotificationPage(state.queryParams)
        state.notificationList = data.data
        state.total = data.total
      } catch (error) {
        console.error(error)
      } finally {
        state.loading = false
      }
    }

    const handleQuery = () => {
      state.queryParams.page = 1
      getList()
    }

    const handleMarkAsRead = (row: any) => {
      ElMessageBox.confirm('是否将该消息置为已读？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        try {
          await markAsRead(row.id)
          ElMessage.success('操作成功')
          getList()
          store.dispatch(NotificationActionTypes.ACTION_GET_UNREAD_COUNT, undefined)
        } catch (error) {
          console.error(error)
        }
      }).catch(() => {})
    }

    const handleGoTo = (row: any) => {
      if (row.targetUrl) {
        if (row.businessId) {
          router.push({ path: row.targetUrl, query: { id: row.businessId } })
        } else {
          router.push({ path: row.targetUrl })
        }
      } else {
        ElMessage.info('该通知无跳转链接')
      }
    }

    onMounted(() => {
      getList()
    })

    return {
      ...toRefs(state),
      getList,
      handleQuery,
      handleMarkAsRead,
      handleGoTo
    }
  }
})
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
